module.exports = "/images/all-contract.svg?c6bbb45c83b5a617c1d50fb54904c25c";